export const validateOnboardingForm = (employeeData, companyData) => {
  const errors = {};

  if (!employeeData.employee_id || !employeeData.employee_id.trim()) {
    errors.employee_id = "Employee ID is required.";
  }
  if (!employeeData.first_name || !employeeData.first_name.trim()) {
    errors.first_name = "First Name is required.";
  }
  if (!employeeData.last_name || !employeeData.last_name.trim()) {
    errors.last_name = "Last Name is required.";
  }
  if (!employeeData.email || !employeeData.email.trim()) {
    errors.email = "Email is required.";
  } else if (!/\S+@\S+\.\S+/.test(employeeData.email)) {
    errors.email = "Email address is invalid.";
  }
  // Add validation for other required fields
  if (!employeeData.dob) {
    errors.dob = "Date of Birth is required.";
  }
  if (!employeeData.contact_number) {
    errors.contact_number = "Contact Number is required.";
  }
  if (!employeeData.state) {
    errors.state = "Residential State is required.";
  }
  if (!employeeData.city) {
    errors.city = "Residential City is required.";
  }
  if (!employeeData.pincode) {
    errors.pincode = "Residential Pincode is required.";
  }
  if (
    !employeeData.residential_address ||
    !employeeData.residential_address.trim()
  ) {
    errors.residential_address = "Residential Address is required.";
  }

  if (!employeeData.adhar) {
    errors.adhar = "Aadhar Card upload is required.";
  }
  if (!employeeData.pan) {
    errors.pan = "PAN Card upload is required.";
  }
  companyData.forEach((company, index) => {
    if (!company.company_name || !company.company_name.trim()) {
      errors[`company_name_${index}`] = "Company Name is required.";
    }
    if (!company.job_title || !company.job_title.trim()) {
      errors[`job_title_${index}`] = "Job Title is required.";
    }
    if (!company.start_date) {
      errors[`start_date_${index}`] = "Start Date is required.";
    }
    // You might want to enforce that start_date is before end_date
    if (
      company.start_date &&
      company.end_date &&
      new Date(company.start_date) > new Date(company.end_date)
    ) {
      errors[`end_date_${index}`] = "End Date cannot be before Start Date.";
    }
    if (!employeeData.adhar) {
      errors.adhar = "Aadhar Card is required.";
    }
    if (!employeeData.pan) {
      errors.pan = "PAN Card is required.";
    }
    // Example for file uploads (if they are mandatory)
    // if (!company.relieving_letter) {
    //   errors[`relieving_letter_${index}`] = "Relieving Letter is required.";
    // }
  });
  if (!employeeData.role_name) {
    errors.role_name = "Role is required.";
  }

  if (!employeeData.attendance_type) {
    errors.attendance_type = "Attendance Type is required.";
  }

  return errors;
};
